import React, { useEffect, useState } from "react";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import { useDispatch } from "react-redux";
import {
  Divider,
  Form,
  Input,
  Row,
  Col,
  Button,
  InputNumber,
  Spin,
  message,
  Select,
} from "antd";

import {
  ADD_STAFF_FAILED,
  ADD_STAFF_SUCCESS,
  UPDATE_STAFF_FAILED,
  UPDATE_STAFF_SUCCESS,
} from "../../constants/message";
import {
  createCompanyStaffs,
  updateCompanyStaffs,
} from "../../redux/actions/companyActions";
import { genders } from "../../constants/staffGenders";
import { replaceMultiple } from "../../utilities/helpers";

const StaffForm = ({
  toggle,
  onSuccess,
  initialValue,
  companyUuid,
  filter,
  config,
  staffRoles,
  staffs,
}) => {
  const dispatch = useDispatch();
  const isEdit = get(initialValue, "name") ? true : false;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [isManager, setIsManager] = useState(false)
  const updateStaff = (payload) => {
    setLoading(true);
    const role = find(Object.values(staffRoles),['value', get(payload, "role_id")]);
    dispatch(
      updateCompanyStaffs(companyUuid, get(initialValue, "id"), payload)
    )
      .then(() => {
        setLoading(false);
        message.success(replaceMultiple(UPDATE_STAFF_SUCCESS,{'{{staff}}':get(role,"name")}));
        onSuccess();
      })
      .catch(() => {
        message.error(replaceMultiple(UPDATE_STAFF_FAILED,{'{{staff}}':get(role,"name")}));
        setLoading(false);
      });
  };
  const managers = staffs.filter((staff) => get(staff, 'role.value') === 1)
  const createStaff = (payload) => {
    setLoading(true);
    const role = find(Object.values(staffRoles),['value', get(payload, "role_id")]);
    dispatch(createCompanyStaffs(companyUuid, payload))
      .then(() => {
        setLoading(false);
        message.success(replaceMultiple(ADD_STAFF_SUCCESS,{'{{staff}}':get(role,"name")}));
        onSuccess();
      })
      .catch(() => {
        message.error(replaceMultiple(ADD_STAFF_FAILED,{'{{staff}}':get(role,"name")}));
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    const payload = {
      name: get(values, "name"),
      role_id: get(values, "role_id"),
      meta: get(values, "meta", {}),
      manager_uuid: get(values, "manager"),
      staff_type :get(values, 'staff_type'),
      emp_id:get(values, "emp_id")
    };
    if (isEdit) {
      updateStaff(payload);
    } else {
      createStaff(payload);
    }
  };

  useEffect(() => {
    if (initialValue && get(initialValue, "role.value") === 1) {
      setIsManager(true)
    } else {
      setIsManager(false)
    }
  }, [initialValue])
  return (
    <Spin spinning={loading}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={() => { }}
        initialValues={{
          ...initialValue,
          company: get(filter, "company.id"),
          template_type: get(filter, "templateType"),
          role_id: get(initialValue, "role.value"),
          manager: get(initialValue, "manager.id"),
          staff_type :get(initialValue, 'staff_type.value'),
          emp_id:get(initialValue, "emp_id","")
        }}
      >
        <Divider />
        <Row gutter={16}>
          <Col xs={12}>
            <Form.Item
              name={"company"}
              label={`Company`}
              rules={[{ required: true, message: "Company is required" }]}
            >
              <Select
                optionFilterProp="label"
                showSearch
                size="middle"
                placeholder="Select Company"
                options={map(get(config, "companies"), (company) => ({
                  label: get(company, "name"),
                  value: get(company, "id"),
                }))}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              name={"role_id"}
              label={`Role`}
              rules={[{ required: true, message: "Role is required" }]}
            >
              <Select
                size="middle"
                placeholder="Select Role"
                options={map(
                  staffRoles,
                  (role) => ({
                    label: get(role, "name", ""),
                    value: get(role, "value", ""),
                  })
                )}
                onChange={(value) => {
                  setIsManager(value === 1)
                }}
              />
            </Form.Item>
          </Col>
           {!isManager && (
            <Col xs={24}>
              <Form.Item
                name={"manager"}
                label={`Select Manager`}
                rules={[{ required: true, message: "Manager is required" }]}
              >
                <Select
                  size="middle"
                  placeholder="Select Manager"
                  options={map(
                    managers,
                    (staff) => ({
                      label: get(staff, "name"),
                      value: get(staff, "id"),
                    })
                  )}
                />
              </Form.Item>
            </Col>
          )}
                 <Col xs={12}>
            <Form.Item
              name={"staff_type"}
              label={`Staff Type`}
              rules={[{ required: true, message: "Staff Type is required" }]}
            >
              <Select
                size="middle"
                placeholder="Select Staff Type"
                options={map(
                  get(config, "staff_types"),
                  (role) => ({
                    label: get(role, "name", ""),
                    value: get(role, "value", ""),
                  })
                )}
              />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              name={"name"}
              label={`Full Name`}
              rules={[{ required: true, message: "Full Name is required" }]}
            >
              <Input placeholder="Full Name" />
            </Form.Item>
          </Col>
     
          <Col xs={24}>
            <Form.Item
              name={"emp_id"}
              label={`Employee Id`}
            >
              <Input placeholder="Employee Id" />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item label="Age" name={["meta", "age"]}>
              <InputNumber
                placeholder="Enter Age"
                precision={0}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item label="Gender" name={["meta", "gender"]}>
              <Select options={genders} placeholder="Select Gender" />
            </Form.Item>
          </Col>
        </Row>
        <div className="w-full bg-white py-4">
          <div className="flex justify-end gap-2">
            <Button
              onClick={() => {
                toggle();
              }}
              className="border-gray-300"
            >
              Close
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
};

export default StaffForm;
